import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import SheetPage from "../components/SheetPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const SheetPageContainer = connect(mapStateToProps, mapDispatchToProps)(SheetPage);

export default SheetPageContainer;


// WEBPACK FOOTER //
// ./src/containers/SheetPageContainer.js